import React from 'react';
import Navbar from '../Navbar';

function MainLayout({ children }) {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Navbar />
      <main className="flex-grow">
        {children}
      </main>
    </div>
  );
}

export default MainLayout;
